export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TOGGLE_DROPDOWN: "TOGGLE_DROPDOWN",
  STORE_EXCEL: "STORE_EXCEL",
  STORE_EXCEL_GROUP: "STORE_EXCEL_GROUP",
  STORE_FEATURED_VIDEOS: "STORE_FEATURED_VIDEOS",
};